"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var useScript = function (scriptAttributes) {
    react_1["default"].useEffect(function () {
        if (!document.querySelector("#" + scriptAttributes.id) &&
            scriptAttributes.src) {
            var newScript_1 = document.createElement('script');
            Object.keys(scriptAttributes).forEach(function (key) {
                newScript_1[key] = scriptAttributes[key];
            });
            document.body.appendChild(newScript_1);
        }
    }, [scriptAttributes]);
};
exports["default"] = useScript;
